const clientCredentials = localStorage.getItem('client') ?
    JSON.parse(localStorage.getItem('client'))
  :
    {token: null}

export const initialState = {client: clientCredentials}
